var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTracabilite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 125 100",
    style: {
      enableBackground: "new 0 0 125 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#000000;}\r\n\t.st1{fill:#EE7203;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.5,24.6c-0.7,0-1.3,0.7-1.3,1.3v46.6c0,0.7,0.7,1.3,1.3,1.3c0.7,0,1.3-0.7,1.3-1.3V25.9 C21,25,20.4,24.6,19.5,24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31.3,24.6c-0.7,0-1.3,0.7-1.3,1.3v46.6c0,0.7,0.7,1.3,1.3,1.3c0.7,0,1.3-0.7,1.3-1.3V25.9 C32.6,25,31.9,24.6,31.3,24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40,72.5V25.9c0-0.7-0.7-1.3-1.3-1.3c-0.7,0-1.3,0.7-1.3,1.3v46.6c0,0.7,0.7,1.3,1.3,1.3S40,73.4,40,72.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M80.8,24.6c-0.7,0-1.3,0.7-1.3,1.3v46.6c0,0.7,0.7,1.3,1.3,1.3c0.7,0,1.3-0.7,1.3-1.3V25.9 C82.1,25,81.5,24.6,80.8,24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M88.1,24.6c-0.7,0-1.3,0.7-1.3,1.3v46.6c0,0.7,0.7,1.3,1.3,1.3c0.7,0,1.3-0.7,1.3-1.3V25.9 C89.5,25,88.8,24.6,88.1,24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M56,72.5V25.9c0-0.7-0.7-1.3-1.3-1.3s-1.3,0.7-1.3,1.3v46.6c0,0.7,0.7,1.3,1.3,1.3S56,73.4,56,72.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M69.2,24.6c-0.7,0-1.3,0.7-1.3,1.3v46.6c0,0.7,0.7,1.3,1.3,1.3c0.7,0,1.3-0.7,1.3-1.3V25.9 C70.5,25,69.9,24.6,69.2,24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.9,72.5V25.9c0-0.7-0.7-1.3-1.3-1.3c-0.7,0-1.3,0.7-1.3,1.3v46.6c0,0.7,0.7,1.3,1.3,1.3 C106.4,73.9,106.9,73.4,106.9,72.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.5,14.3c0-0.7-0.7-1.3-1.3-1.3H3.6c-0.7,0-1.3,0.7-1.3,1.3v14.5c0,0.7,0.7,1.3,1.3,1.3S5,29.5,5,28.8V15.7 h13.2C18.8,15.7,19.5,15,19.5,14.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M122.9,28.8V14.3c0-0.7-0.7-1.3-1.3-1.3h-14.5c-0.7,0-1.3,0.7-1.3,1.3s0.7,1.3,1.3,1.3h13.2v13.2 c0,0.7,0.7,1.3,1.3,1.3C122.3,30.2,122.9,29.5,122.9,28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2.1,72.5v13.2c0,0.7,0.7,1.3,1.3,1.3h14.5c0.7,0,1.3-0.7,1.3-1.3c0-0.7-0.7-1.3-1.3-1.3H4.7V72.5 c0-0.7-0.7-1.3-1.3-1.3S2.1,71.9,2.1,72.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M105.5,85.7c0,0.7,0.7,1.3,1.3,1.3h14.5c0.7,0,1.3-0.7,1.3-1.3V72.5c0-0.7-0.7-1.3-1.3-1.3s-1.3,0.7-1.3,1.3 v11.8h-12.9C106.2,84.3,105.5,85,105.5,85.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTracabilite);
export default __webpack_public_path__ + "static/media/tracabilite.a54d8ff1d5cc0b1bed4ea28df7d8562a.svg";
export { ForwardRef as ReactComponent };